import { render } from "./DashboardWebPageComponent.vue?vue&type=template&id=a0b2a5ba&scoped=true"
import script from "./DashboardWebPageComponent.vue?vue&type=script&lang=js"
export * from "./DashboardWebPageComponent.vue?vue&type=script&lang=js"

import "./DashboardWebPageComponent.vue?vue&type=style&index=0&id=a0b2a5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b2a5ba"]])

export default __exports__